module.exports = __webpack_public_path__ + "static/media/resume.435df69c.pdf";